import Component from 'vue-class-component'
import { Vue, Mixins } from 'vue-property-decorator'
import moment from 'moment'
import { Cow } from '@/interfaces/Cow'
import TimeService from '@/services/time-service'

@Component
class CowService extends Mixins(TimeService) {
  getAges() {
    const months = []
    for (let i = 0.01; i <= 0.11; i = i + 0.01) {
      months.push({
        text: `${Math.round(i * 100)} ${i === 0.01 ? 'mes' : 'meses'}`,
        value: i,
      })
    }
    const years = []
    for (let i = 1; i <= 15; i++) {
      years.push({ text: `${i} ${i === 1 ? 'año' : 'años'}`, value: i })
    }
    return months.concat(years)
  }

  getPregnantSinces() {
    const months = [{ text: 'Vacia', value: 0 }]
    for (let i = 0; i <= 20; i = i + 0.5) {
      months.push({ text: `${i} ${i === 1 ? 'mes' : 'meses'}`, value: i })
    }
    return months
  }

  getIrons() {
    const mains = [
      'Sin',
      'AGP',
      'AGP-GB',
      'AGB-REY',
      'CPL',
      'm73',
      'm74',
      'm74-%58',
      'm74-PAB',
      'm74-PB',
      'PAB',
      'PAB-RA',
      'PB',
      'PB-AGP',
      'PB-C1V',
      'PB-REY',
      'TA73',
    ]
    const irons: { text: string; value: string }[] = []
    mains.forEach((hierro: string) => {
      irons.push({ text: hierro, value: hierro === 'Sin' ? null : hierro })
    })
    return irons
  }

  getMaxAge() {
    return Math.max(
      ...this.getAges().map((age: { text: string; value: number }) => {
        return age.value
      })
    )
  }
  getMinAge() {
    return Math.min(
      ...this.getAges().map((age: { text: string; value: number }) => {
        return age.value
      })
    )
  }

  getMinPregnantSince() {
    return Math.min(
      ...this.getPregnantSinces().map(
        (pregnantSince: { text: string; value: number }) => {
          return pregnantSince.value
        }
      )
    )
  }

  getMaxPregnantSince() {
    return Math.max(
      ...this.getPregnantSinces().map(
        (pregnantSince: { text: string; value: number }) => {
          return pregnantSince.value
        }
      )
    )
  }

  addPregnantSinceAndAge(cows: Cow[]) {
    const newCows = []
    cows.forEach((cow: Cow) => {
      cow.pregnantSince = this.getPregnantSince(cow.pregnancyDate)
      cow.age = this.getAge(cow.birthDate)
      newCows.push(cow)
    })
    return newCows
  }

  getFarms() {
    return [
      { text: 'Consuleo', value: 'consuelo' },
      { text: 'Porfia', value: 'porfia' },
    ]
  }

  getFertilities() {
    return [
      { text: 'Becerro', value: 'becerro' },
      { text: 'Levante', value: 'levante' },
      { text: 'Vaca', value: 'vaca' },
      { text: 'Descarte', value: 'descarte' },
      { text: 'Macho', value: 'macho', disabled: true },
    ]
  }

  getGenders() {
    return [
      { text: 'Hembra', value: 'female' },
      { text: 'Macho', value: 'male' },
    ]
  }

  getGender(female: boolean) {
    return female ? 'female' : 'male'
  }

  getColor(date: string) {
    const ageInMonth = moment().diff(moment(date, 'YYYY-MM-DD'), 'months')
    if (ageInMonth > 7) {
      return true
    } else {
      return false
    }
  }

  getMonthText(pregnantSince: number) {
    if (pregnantSince === 0) {
      return 'Vacia'
    } else if (pregnantSince < 0) {
      return 'Error'
    } else {
      return `${pregnantSince} ${pregnantSince === 1 ? 'mes' : 'meses'}`
    }
  }

  getAgeText(age: number) {
    if (age < 1) {
      return `${Math.round(age * 100)} ${age === 0.01 ? 'mes' : 'meses'}`
    }
    return `${age} ${age === 1 ? 'año' : 'años'}`
  }

  getRaceName(item: any) {
    const race = this.$store.state.account.races.find(
      r => r.id === item.race_id
    )
    if (race) {
      return race.name
    }
  }
  getIronName(item: any) {
    const iron = this.$store.state.account.irons.find(
      i => i.id === item.iron_id
    )
    if (iron) {
      return iron.name
    }
  }

  getFarmName(item: any) {
    const farm = this.$store.state.account.farms.find(
      f => f.id === item.farm_id
    )
    if (farm) {
      return farm.name
    }
  }
}
export default CowService
